import * as React from 'react'
import './index.scss'
import { OrderCardProps } from './types'
import Lottie from 'lottie-react'
import { Skeleton } from '@petz/ds-skeleton'
import { SegmentContext } from '../../hooks/SegmentContext'

export const OrderCard: React.FC<OrderCardProps> = ({ order }: OrderCardProps) => {
  const badgeHiddenStatus = ['retirada liberada', 'pedido retirado', 'pedido entregue']

  const { deliveryDateDetailsText, emAtraso, idPedido, numeroPedido, statusPedido, urlIconeAnimado, newDeliveryDateText } = order

  const { segmentTrack } = React.useContext(SegmentContext)
  const [animationData, setAnimationData] = React.useState(null)

  React.useEffect(() => {
    const fetchLottieAnimation = async () => {
      try {
        const response = await fetch(urlIconeAnimado)
        if (!response.ok) {
          throw new Error(`Erro ao carregar a animação: ${response.statusText}`)
        }
        const data = await response.json()
        setAnimationData(data)
      } catch (error) {
        console.error('Erro ao carregar o Lottie:', error)
      }
    }

    if (urlIconeAnimado) {
      fetchLottieAnimation()
    }
  }, [urlIconeAnimado])

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    segmentTrack('Help Option Clicked', {
      widget: true,
      alt_text: 'ajuda-alt',
      help_section: 'Acompanhar pedido',
      help_subsection: 'Acompanhar pedido',
      button_name: statusPedido,
      link_url: `/petz-pedidos/${idPedido}`,
    })

    window.location.href = `/petz-pedidos/details/${idPedido}`
  }

  return (
    <a className="order-card-container" href={`/petz-pedidos/details/${idPedido}`} data-testid="order-card" onClick={handleClick}>
      <div className="order-card-icon-container">
        {animationData ? <Lottie animationData={animationData} loop autoplay style={{ width: 64, height: 64 }} /> : <Skeleton height={64} width={64} />}
      </div>
      <div className="order-card-text-container">
        <p className="order-id">{`#${numeroPedido}`}</p>
        <p className="order-status">{statusPedido}</p>
        <p className="order-description">{newDeliveryDateText ?? deliveryDateDetailsText}</p>
      </div>
      {!badgeHiddenStatus.includes(statusPedido.toLocaleLowerCase()) ? (
        <div className="order-badge-container">
          <span className={`order-badge ${emAtraso ? 'order-badge-delayed' : 'order-badge-on-time'}`}>{emAtraso ? 'Em atraso' : 'No prazo'}</span>
        </div>
      ) : null}
    </a>
  )
}
